import authentication from './modules/authentication'
import orgApproval from './modules/orgApproval'


export default {
  authentication,
  orgApproval,
}



// WEBPACK FOOTER //
// ./src/store/attestation/index.js